import { GripVertical } from 'lucide-react'
import * as ReResizable from 're-resizable'
import {
  Group,
  Panel,
  Separator,
  type GroupProps,
  type SeparatorProps,
} from 'react-resizable-panels'

import { cn } from '@/lib/utils'

const PanelGroup = ({ className, ...props }: GroupProps) => (
  <Group
    className={cn('flex h-full w-full data-[panel-group-direction=vertical]:flex-col', className)}
    {...props}
  />
)

const PanelSeparator = ({
  withHandle,
  className,
  ...props
}: SeparatorProps & {
  withHandle?: boolean
}) => (
  <Separator
    className={cn(
      'relative flex w-0 items-center justify-center outline-none after:absolute after:inset-y-0 after:start-1/2 after:w-2 after:-translate-x-1/2',
      className,
    )}
    {...props}
  >
    {withHandle && (
      <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-gray-5">
        <GripVertical className="h-2.5 w-2.5" />
      </div>
    )}
  </Separator>
)

const ResizableBox = ReResizable.Resizable

export { Panel, PanelGroup, PanelSeparator, ResizableBox }
